import React from 'react';
import PropTypes from 'prop-types';

const generateId = () => Math.random().toString(16).slice(2);

/**
 * Table cell representing checkbox for row
 *
 * @param rowData
 * @param onSelect
 * @param isSelected
 * @returns {XML}
 * @constructor
 */
function SelectedCell({ rowData, onSelect, isSelected }) {
    const index = generateId();
    const selectedCellClassName =
        'sales__catalogueRefineLotsEntriesWrp sales__catalogueRefineLotsEntriesWrp_centered';
    return (
        <div className={selectedCellClassName}>

            <label htmlFor={index} className="checkbox_holder">
                <input
                    type="checkbox"
                    id={index}
                    checked={isSelected}
                    onChange={() => (rowData ? onSelect(rowData) : onSelect())}
                    className="ui-checkbox_input"
                />
                <span className="ui-checkbox" />
            </label>
        </div>
    );
}

SelectedCell.propTypes = {
    /**
     * Single row data
     */
    rowData: PropTypes.object,
    /**
     * On row select event handler
     */
    onSelect: PropTypes.func,
    /**
     * Is row selected
     */
    isSelected: PropTypes.bool
};

export default SelectedCell;



// WEBPACK FOOTER //
// ./src/js/components/DataTable/SelectedCell.js